import {
  GET_MERCHANTS_STATS,
  GET_DRIVERS_STATS,
  GET_MERCHANTS_STATS_ERROR,
  GET_DRIVERS_STATS_ERROR,
} from "../constants/StatsConstants";
import Axios from "axios";
import { API_ROOT } from "../components/utils/api-config";
let token = "Bearer " + localStorage.getItem("token");
const config = {
  headers: {
    Authorization: token,
  },
};
export const getMerchantsStats = (sort) => (dispatch) => {
  Axios.get(`${API_ROOT}/stats/merchantstats?sort=${sort}`, config)
    .then((response) =>
      dispatch({ type: GET_MERCHANTS_STATS, payload: response.data })
    )
    .catch((error) =>
      dispatch({ type: GET_MERCHANTS_STATS_ERROR, payload: error })
    );
};

export const getDriversStats = () => (dispatch) => {
  Axios.get(`${API_ROOT}/stats/driverstats/`, config)
    .then((response) =>
      dispatch({ type: GET_DRIVERS_STATS, payload: response.data })
    )
    .catch((error) =>
      dispatch({ type: GET_DRIVERS_STATS_ERROR, payload: error })
    );
};
